import axios from 'axios'

const verificarPendencia = async function () {
  console.log('=== verificarPendencia iniciou ===')

  const apiUrl = `${process.env.VUE_APP_PINPAD_API_URL}/totem/pendencias.php`

  const headers = {
    'Content-Type': 'application/json'
  }

  try {
    const response = await axios.post(apiUrl, {}, { headers })

    // console.log('verificarPendencia sucesso:', response.data)

    if (response.data?.sucesso === true) {
      return response.data
    }

    throw new Error(response.data?.mensagem || 'Falha ao verificar pendências')
  } catch (error) {
    console.error('Erro no axios.post de verificarPendencia:', error.response?.data || error.message)
    throw error
  }
}

export { verificarPendencia }